// ============================================================
// FILE: resources/js/stores/auth.js
// USPATIH GO — Alpine Store: Auth (User & Token)
// ============================================================

import Alpine from 'alpinejs';
import axios from '../config/axios.js';
import { API_BASE } from '../config/axios.js';
import {
  clearUserClientState,
  hardNavigate,
  resetAlpineStores,
} from '../utils/sessionCleanup.js';

function readStoredUser() {
  try {
    return JSON.parse(localStorage.getItem('uspatih_user') || 'null');
  } catch {
    return null;
  }
}

Alpine.store('auth', {
  user:  readStoredUser(),
  token: localStorage.getItem('uspatih_token') || null,

  // ---- Getters -----------------------------------------------
  get isLoggedIn() {
    return !!(this.token || (typeof localStorage !== 'undefined' && localStorage.getItem('uspatih_token')));
  },
  get isAdmin()    { return this.user?.roles?.includes('admin') || this.user?.roles?.includes('super_admin'); },
  get isKasir()    { return this.user?.roles?.includes('kasir'); },
  get isDriver()   { return this.user?.roles?.includes('driver'); },
  get isCustomer() { return this.user?.roles?.includes('customer'); },

  // ---- Actions -----------------------------------------------

  /**
   * Simpan data auth setelah login berhasil.
   * Jika ganti user, bersihkan state klien user sebelumnya dulu.
   */
  setAuth(user, token) {
    const prevId = this.user?.id;
    const nextId = user?.id;

    if (prevId && nextId && String(prevId) !== String(nextId)) {
      clearUserClientState({ keepTheme: true });
    }

    this.user  = user;
    this.token = token;
    if (token) {
      localStorage.setItem('uspatih_user', JSON.stringify(user));
      localStorage.setItem('uspatih_token', token);
      sessionStorage.setItem('uspatih_auth_fresh_at', String(Date.now()));
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    }
    resetAlpineStores();
  },

  /**
   * Hapus data auth lokal (tanpa revoke token di server).
   */
  clearAuth() {
    this.user  = null;
    this.token = null;
    clearUserClientState();
    delete axios.defaults.headers.common['Authorization'];
  },

  /**
   * Logout penuh: revoke token Sanctum + bersihkan storage + redirect.
   * @param {{ redirect?: string|null, revokeToken?: boolean }} opts
   */
  async logoutUser(opts = {}) {
    const { redirect = '/', revokeToken = true } = opts;
    const token = this.token;

    this.user  = null;
    this.token = null;
    clearUserClientState();
    delete axios.defaults.headers.common['Authorization'];

    if (revokeToken && token) {
      try {
        await axios.post(`${API_BASE}/auth/token-logout`, {}, {
          headers: { Authorization: `Bearer ${token}` },
        });
      } catch { /* token mungkin sudah expired */ }
    }

    if (redirect) {
      hardNavigate(redirect);
    }
  },
});
